export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/mask.28916ca1-aea866.png";